export default "__VITE_ASSET__CSvDrfZO__"